import useIsMobile from '../../hooks/useIsMobile';

function RafTermsAndConditions() {
  const { isMobile } = useIsMobile();

  return (
    <div
      className={`px-4 md:px-24 mx-auto py-10 leading-6 ${
        isMobile ? 'px-5' : ''
      }`}
    >
      <section>
        <h1 className='text-2xl md:text-[40px] text-[#2D2D2D] md:leading-[40px] mb-6 font-bold'>
          Terms and Conditions – “Refer a Friend Bonus Program”
        </h1>
        <p className='mb-2'>Effective Date: October 1, 2025</p>
        <p className='italic mb-6'>
          The below Terms &amp; Conditions are an addition to the regular App
          Terms &amp; Conditions.
        </p>

        <ol className='list-decimal mt-8 ml-[1.2rem] space-y-6'>
          <li>
            <h3 className='font-bold mb-2'>Eligibility</h3>
            <div className='space-y-2'>
              <p>
                The RAF Promotion is open to existing Program members
                ('Referrers') and new members ('Referred Members').
              </p>
              <p>
                Only one referral link or code may be used per new member
                sign-up.
              </p>
              <p>
                Referred Members must not have an existing or previous Program
                Account.
              </p>
              <p>
                The RAF Promotion is a limited-time promotion valid until{' '}
                <strong className='underline'>Dec 31, 2026</strong>, unless
                renewed earlier.
              </p>
              <p>
                Only <strong>Qualifying Purchases</strong> will count towards a
                member achieving their target for getting the bonus reward. A
                purchase is considered a Qualifying Purchase when it is
                completed using a member's Enrolled Card, meets all the relevant
                Offer's terms and conditions, and is confirmed by the Merchant
                as final and irreversible.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Referral Bonus Structure</h3>
            <div className='space-y-2'>
              <p>
                Both the Referrer and Referred Member are eligible to earn a $5
                bonus when the Referred Member spends a total of $25 or more on
                Qualifying Purchases within 90 days of sign-up. The Referred
                Member's $25 spend can occur across one or more Qualifying
                Purchases.
              </p>
              <p>
                The $5 bonus initially appears in 'Pending' status and only
                moves to 'Confirmed' status once the relevant purchase(s) is/are
                confirmed by the Merchant(s) as final and irreversible.
                Confirmation of purchases is at the sole discretion of the
                Merchant, and can take up to 120+ days in some cases.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Bonus Statuses Explained</h3>
            <div className='space-y-2'>
              <p>
                <strong>Pending:</strong> Displayed immediately upon the
                Referred Member's sign-up.
              </p>
              <p>
                <strong>Confirmed:</strong> Once the Referred Member's purchases
                of $25 or more become Qualifying Purchases.
              </p>
              <p>
                <strong>Expired:</strong> If no Qualifying Purchases of $25 or
                more are completed within 90 days of sign-up or if any
                Qualifying Purchases are reversed or rejected.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Payment &amp; Lifetime Totals</h3>
            <div className='space-y-2'>
              <p>
                Confirmed bonuses will be paid out in the next eligible payout
                cycle on the 15th of each month if the payout threshold of $10
                is met.
              </p>
              <p>
                'Lifetime Payouts' displays all bonuses paid to date excluding
                currently Pending or Confirmed bonuses awaiting payout.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Program Restrictions</h3>
            <div className='space-y-2'>
              <p>
                Bonuses are only applicable when a valid Referrer is identified.
              </p>
              <p>
                Self-referrals, duplicate accounts, or referrals generated
                through fraudulent activity will be disqualified.
              </p>
              <p>
                The Referred Member must meet all eligibility and spend criteria
                for both the Referrer and the Referred Member to receive the
                bonus.
              </p>
              <p>
                Savers App reserves the right to verify transactions and
                eligibility before confirming bonuses.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Reversals and Cancellations</h3>
            <p>
              If any Qualifying Purchase is reversed, cancelled, or refunded
              after confirmation, the associated bonus may be forfeited or
              reversed.
            </p>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Program Changes</h3>
            <div className='space-y-2'>
              <p>
                Savers App reserves the right to modify, suspend, or terminate
                the RAF Promotion at any time without prior notice. Bonuses
                issued before any modification will remain valid according to
                the terms in effect at the time they were earned.
              </p>
            </div>
          </li>

          <li>
            <h3 className='font-bold mb-2'>Disputes</h3>
            <div className='space-y-2'>
              <p>
                Any discrepancies regarding referral bonuses must be reported
                within 60 days of the relevant transaction by contacting support
                through the App. Savers App's decision in all matters related to
                the RAF Promotion is final and binding.
              </p>
            </div>
          </li>
        </ol>
      </section>
    </div>
  );
}

export default RafTermsAndConditions;
